import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CustomerTypeService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/customertype", data);
    return response.data;
  },
  update: async (updatedData) => {
    try {
      const response = await apiService.put(`/customertype`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    const response = await apiService.get("/customertype");
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/customertype/${id}`);
    return response.data;
  },
 
  delete: async (id) => {
    const response = await apiService.delete(`/customertype/${id}`);
    return response.data;
  },
};

export default CustomerTypeService;
